<template>
  <el-select
    v-model="callback.advertiser_id"
    v-loading="loading"
    placeholder="请选择广告主"
    size="mini"
    filterable
    clearable
    v-bind="selectProp"
    @change="valueChange"
  >
    <el-option
      v-for="(item, index) in response.list"
      :key="index"
      :value="item.advertiser_id.toString()"
      :label="item.advertiser_name"
    >
      {{ item.advertiser_name }}
      <a style="color:darkgray">{{ item.note }}</a>
    </el-option>
  </el-select>
</template>

<script>
import MediasResource from '@/api/medias';
const mediasResource = new MediasResource();
export default {
  name: 'MediaSelect',
  model: {
    prop: 'advertiser_id',
    event: 'change',
  },
  props: {
    type: {
      type: String,
      default: '',
    },

    selectProp: {
      type: Object,
      default: () => {
        return {};
      },
    },

    advertiserId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      params: {
        type: this.type,
        is_list: true,
      },
      response: {
        list: [],
      },
      callback: {
        advertiser_id: this.advertiser_id,
      },
    };
  },
  created() {
    this.getMediasList();
  },
  methods: {
    // 获取媒体用户列表
    async getMediasList() {
      this.loading = true;
      await mediasResource
        .getMediasListApi(this.params)
        .then(response => {
          this.response.list = response.list;
        })
        .catch(error => {
          console.log(error);
        })
        .then(() => {
          this.loading = false;
        });
    },

    // 清空值
    clearValue(){
      this.callback.advertiser_id = '';
    },

    // 回调
    valueChange(value) {
      this.$emit('change', value);
    },
  },
};
</script>
